import {HttpService} from "./http";

class ClientService extends HttpService {
    public constructor() {
        super("/client-app/client");
    }


    public me(): any {
        return this.http
            .get(this.route + "/me")
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }

    public profileDetails(): any {
        return this.http
            .get(`${this.route}/profile/details`)
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }

    public update(profileData: any): any {
        return this.http
            .post(this.route + "/", profileData)
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }

    public addresses(): any {
        return this.http
            .get(this.route + "/me/addresses")
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }

    public createAddress(addressData: any): any {
        return this.http
            .post(this.route + "/addresses", addressData)
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }

    public updateEmergency(addressData: any): any {
        return this.http
            .put(`${this.route}/addresses/emergency`, addressData)
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }

    public updatePrimary(addressData: any): any {
        return this.http
            .put(`${this.route}/addresses/primary`, addressData)
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }

    public updateShipping(addressData: any): any {
        return this.http
            .put(`${this.route}/addresses/shipping`, addressData)
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }

    public updateGpDetails(gpDetails: any): any {
        return this.http
            .put(`${this.route}/medical/details`, gpDetails)
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }

    public updateInsuranceDetails(insuranceDetails: any): any {
        return this.http
            .put(`${this.route}/insurance/details`, insuranceDetails)
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }

    public switchAccount(clientId: number): any {
        return this.http
            .post(`${this.route}/switch-account`, { client_id: clientId })
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }
}

export const clientService: ClientService = new ClientService();
